import { useCallback, useState } from 'react';
import { AppModal, AppRemixIcon } from '@/layout/AppComponents';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import colors from '../../../constants/colors';
import minions from '../../../minions/minions';
import useIsMounted from '../../components/hooks/useIsMounted';
import { axiosPath } from '../../../routing/helpers/router';
import errorHandler from '../../components/error/ErrorHandler';
import _ from 'lodash';

export default function ObligationFormQuestionHelp(props) {
  const { question } = props;
  const dispatch = useDispatch();
  const isMounted = useIsMounted();
  const [showHelpQuestion, setShowHelpQuestion] = useState(false);

  const handleDownloadFile = useCallback(async (key, fileName) => {
    axios
      .post(
        axiosPath(
          "api_r_user_m_legalCompliance_plantObligationForm_help_file_download"
        ),
        { questionID: question.id, key, fileName }
      )
      .then((r) => {
        if (isMounted.current) {
          window.open(r.data, "_blank");
        }
      })
      .catch((e) => dispatch(errorHandler(e)));
  }, []);

  return (
    <>
      {question.helpText && (
        <>
          <AppRemixIcon
            icon="file-text"
            color={colors.primary}
            size="20"
            onClick={() => setShowHelpQuestion(true)}
            className="pointer"
            title="Información"
          />
          <AppModal
            show={showHelpQuestion}
            title="Información"
            size="xl"
            onClose={() => setShowHelpQuestion(false)}
            isCancelBtn
          >
            <div
              dangerouslySetInnerHTML={{
                __html: question.helpText,
              }}
            />

            <div
              className="mt-3 mb-2"
              style={{
                height: '1px',
                backgroundColor: '#ccc',
                width: '100%',
              }}
            />

            {Object.keys(question?.helpFiles || {}).length > 0 &&
              _.map(question?.helpFiles, (file, i) => (
                <div
                  key={i}
                  style={{ fontSize: '20px' }}
                  className="pointer"
                  onClick={() => handleDownloadFile(i, file.name)}
                >
                  {minions.files.fileIcon(file.name, true, null, 'mr-2')}
                  {file.name}
                </div>
              ))}
          </AppModal>
        </>
      )}
    </>
  );
}
